import toast from 'react-hot-toast';
import config from '../../../../config';
import { getAuthToken } from '../../../utils/auth';

const putBulkToggle = async (activeState, publisherId, categoryId) => {
  const accessToken = getAuthToken();

  const response = await fetch(
    `${config.ApiBaseUrl}/publisher/${publisherId}/articleCategory/${categoryId}/active/${activeState}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  const json = await response.json();

  const { message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return success;
};

const useToggleActivation = (selectedCategories, publisherId) => {
  const handleToggle = (activeState) => {
    const arr = [];
    selectedCategories.forEach((value, key) => {
      if (value) {
        arr.push(putBulkToggle(activeState, publisherId, key));
      }
    });
    // for (const [key, value] of selectedCategories) {
    //   if (value) {
    //     arr.push(putBulkToggle(activeState, publisherId, key));
    //   }
    // }

    Promise.all(arr)
      .then(() => {
        if (activeState)
          toast.success('Selected categories activated successfully!');
        else toast.success('Selected categories deactivated successfully!');
      })
      .catch((e) => {
        toast.error('something went wrong!');
      });
  };

  return handleToggle;
};

export default useToggleActivation;
